import { SseRecord } from '../models';
import ApiResource from './ApiResource';

class SseRecordResource extends ApiResource<SseRecord> {
  public endpoint = '/sse_records';
}

export const sseRecordResource = new SseRecordResource();
